module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n    page_0040_certificate_software_detail\n  ")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [(_vm.showSurplusAlertMessage) ? _c('div', {
    staticClass: "col-xs-12 surplus_msg"
  }, [_vm._v("\n        以下のソフトウェア情報は余剰ライセンスです。"), _c('br'), _vm._v("\n        割当を希望される場合、[編集]ボタンより[所管区分][所管部署][所管チーム][所管システム(IT所管システムの場合)][申請者名（ﾌﾙﾈｰﾑ）][管理担当者名（ﾌﾙﾈｰﾑ）]欄を記入し、[申請]ボタンより申請を行ってください。"), _c('br'), _vm._v("\n        ※ライセンス数は変更できません。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loadBy == 'deposit_certificate_output') ? _c('title-and-slot', {
    attrs: {
      "title": "預り証出力（詳細）"
    }
  }) : _c('title-and-slot', {
    attrs: {
      "title": "証書情報（詳細）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "25%",
      "float": "left",
      "margin-left": "-25px",
      "min-width": "100px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v(" ＜　戻る")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日：" + _vm._s(_vm.updateDate) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          登録日：" + _vm._s(_vm.registrationDate) + "\n        ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      承認状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "90px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.approvalStatus
    }
  }), _vm._v("\n      状態:\n      "), _c('select', {
    staticClass: "status_field",
    style: (_vm.statusFieldStyle),
    attrs: {
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.Status
    },
    on: {
      "change": function($event) {
        _vm.Status = $event.target.value
      }
    }
  }, _vm._l((_vm.StatusOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "selected": option == _vm.Status,
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })), _vm._v("\n      申請No：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "140px",
      "padding-left": "4px",
      "margin": "2px",
      "margin-bottom": "-6px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px",
      "color": "#008cff",
      "text-decoration": "underline"
    },
    attrs: {
      "type": "button",
      "value": _vm.approvalHistoryTorokuNumber
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  }), _vm._v(" "), (_vm.showApprovalHistoryBulkTorokuNumberQty) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※この申請は一括申請です。同一の申請が " + _vm._s(_vm.approvalHistoryBulkTorokuNumberQty) + " 件あります。")]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id],
        "option": {
          rows: 2
        }
      }
    })
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == false),
      expression: "draftWriteMode == false"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalUpSaveCertificateSoftware
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.draftWriteMode == true),
      expression: "draftWriteMode == true"
    }],
    staticClass: "btn btn-primary on_local_save_certificate_software",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveCertificateSoftware
    }
  }, [_vm._v("下書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary btn_cancel_btn",
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideEditMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary on_edit_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableEditMainBtn || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": function($event) {
        _vm.processApprovalApprove()
      }
    }
  }, [_vm._v("確認")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyRejectBtn == false && _vm.hideApplyConfirmationBtn == true && _vm.approvalcancelmode == false),
      expression: "hideApplyRejectBtn == false && hideApplyConfirmationBtn == true &&  approvalcancelmode == false "
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbeddedReason
    }
  }, [_vm._v("取戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplyConfirmationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplyConfirmationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("差戻")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideApplicationBtn == false && _vm.approvalcancelmode == false),
      expression: "hideApplicationBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary on_confirm_execute_process_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.disableApplicationBtn || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onConfirmExecuteProcess
    }
  }, [_vm._v("申請")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCopyMainBtn == false && _vm.approvalcancelmode == false),
      expression: "hideCopyMainBtn == false && approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary clone_record_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.forceDisableDueUpgradeDestination || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.cloneRecord
    }
  }, [_vm._v("\n        コピー\n      ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == false),
      expression: "approvalcancelmode == false"
    }],
    staticClass: "btn btn-warning show_device_btn",
    attrs: {
      "disabled": _vm.isSurplus || _vm.forceDisableDueUpgradeDestination || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false || _vm.loadBy == 'deposit_certificate_output'
    },
    on: {
      "click": _vm.onLinkDevice
    }
  }, [_vm._v("機器")]), _vm._v(" "), (_vm.is_new == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == false),
      expression: "approvalcancelmode == false"
    }],
    staticClass: "btn btn-primary show_history_btn",
    attrs: {
      "disabled": _vm.disableAllButtons || _vm.checkUserPermission(true, _vm.permissionMode.BROWSE) == false
    },
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("更新履歴")]) : _vm._e(), _vm._v(" "), (_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "-10px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.approvalCancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.approvalcancelmode == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-right": "10px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onapprovalSaveDevEmbedded
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.approvalcancelmode == true),
      expression: "approvalcancelmode == true"
    }]
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "15px",
      "margin-right": "-190px",
      "font-weight": "800",
      "margin-top": "-23px",
      "letter-spacing": "1px",
      "color": "red"
    }
  }, [_vm._v("※差戻通知を入力し、入力完了をクリックして下さい。(任意)\n          ")])])]), _vm._v(" "), _c('certificate-sub-page', {
    attrs: {
      "controller": _vm.subTableController,
      "disable_pdf_btn": _vm.disablepdfButtons
    }
  })], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationUpAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationUpAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancel"
    },
    on: {
      "done": _vm.processApprovalCancelBack
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddcancelReason"
    },
    on: {
      "done": _vm.processApprovalCancelBackReason
    }
  }), _vm._v(" "), _c('certificate-information-connection-application-modal', {
    attrs: {
      "tag": "showBulkImportConfimationModal"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmUnlinkDevices"
    },
    on: {
      "done": _vm.onConfirmUnlinkDevices
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSave"
    },
    on: {
      "done": _vm.afterTheNotificationAfterSave
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterCertificateSoftwareApprovalStartedRequest"
    },
    on: {
      "done": _vm.afterTheNotificationAftercancel
    }
  }), _vm._v(" "), _c('application-confirmation-modal', {
    attrs: {
      "tag": "certificateApplicationConfimationModal"
    }
  }), _vm._v(" "), (_vm.enableHistoryModal) ? _c('change-history', {
    attrs: {
      "tag": "showCertificateSoftwareChangeHistoryModal",
      "id_label": "証書管理番号"
    }
  }) : _vm._e(), _vm._v(" "), _c('certificate-software-linked-upgrade-modal', {
    attrs: {
      "tag": "showCertificateSoftwareLinkedUpgradeModal"
    },
    on: {
      "selected": _vm.onSelectedUpgradeCertificate
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteCertificateInformationDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("\n          ＊入力必須項目\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px",
      "margin": "-15px"
    }
  }, [_c('h3', [_vm._v("ソフトウェア情報")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e92c7a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0040_certificate_software_detail.vue
// module id = 946
// module chunks = 0